import { styled } from '@mui/material';
import React from 'react';

const StyledLoader = styled('div')(({ theme }) => ({
  border: '4px solid rgb(51, 204, 204)',
  // borderLeft: '4px solid',
  animation: 'load 1s infinite linear',
  borderRadius: '50%',
  width: 25,
  height: 25,

  '@keyframes load': {
    '0%': {
      transform: 'rotate(0deg)',
    },
    '100%': {
      transform: 'rotate(360deg)',
    },
  },
}));

function Loader() {
  return <StyledLoader />;
}

export default Loader;
